if (!customElements.get('delivery-dates')) {
  customElements.define(
    'delivery-dates',
    class DeliveryDates extends HTMLElement {
      connectedCallback() {
        this.deliveryDatesText = this.querySelector('[data-delivery-date]');
        this.unsubscribe = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          ({ data: { html } }) => {
            const updated = html.querySelector('[data-delivery-date]');
            if (updated) this.deliveryDatesText.textContent = updated.textContent;
          }
        );
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    }
  );
}